import styled, { css } from "styled-components";
import FlexBox from "../../../../FlexBox/FlexBox";
import { responsiveMap } from "../../../../Grid/_utils/responsiveObserve";

export const _InnovationProductUmamiRoot = styled(FlexBox)<{}>(
  () => {
    return {
      position: "relative",
      overflow: "hidden",
      ".innovation-umami-product-video": {
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
      },
      ".innovation-umami-product-action-button": {
        marginTop: 19 - 13, // value - gap
        [`@media ${responsiveMap.mobile}`]: {
          width: "100%",
        },
        "&.text-on-desktop": {
          [`@media ${responsiveMap.mobile}`]: {
            width: "unset",
          },
        },
      },
    };
  },
  css`
    .innovation-product.action-on-hover {
      position: relative;
      &:hover {
        .action-on-hover--overlay {
          opacity: 1;
        }
      }
    }

    .action-on-hover--overlay {
      position: absolute;
      left: 0px;
      top: 0px;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.6);

      padding: 0 10px 29px;
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      opacity: 0;

      transition: opacity 0.3s ease-out;
    }

    .innovation-umami-product-content {
      @media ${responsiveMap.mobile} {
        height: 100vh;
        height: -webkit-fill-available;
        height: 100dvh;
      }
    }
  `
);
